import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function CheckCircleIcon({
  className,
  fill = IconColors.DarkGrey,
  height = 18,
  width = 18,
}: SimpleIconInterface) {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height}
      viewBoxDimensions="0 0 14 14"
      width={width}
    >
      <path
        d="M10.0119 5.04372C10.2183 5.24984 10.2183 5.58428 10.0119 5.7904L6.3181 9.48425C6.11197 9.6906 5.77753 9.6906 5.57141 9.48425L3.98833 7.90117C3.70093 7.61377 3.83243 7.12303 4.22503 7.01783C4.40723 6.96901 4.60164 7.0211 4.73502 7.15449L5.94475 8.36488L9.26526 5.04372C9.47138 4.83737 9.80582 4.83737 10.0119 5.04372ZM13.8601 7.00014C13.8601 12.281 8.14347 15.5815 3.57014 12.9411C-1.0032 10.3007 -1.0032 3.69962 3.57014 1.0592C4.61299 0.457111 5.79596 0.140137 7.00014 0.140137C10.7872 0.14414 13.8561 3.21312 13.8601 7.00014ZM12.8048 7.00014C12.8048 2.53174 7.96758 -0.261007 4.09783 1.97319C0.228086 4.20739 0.228086 9.79288 4.09783 12.0271C4.98017 12.5365 5.9813 12.8047 7.00014 12.8047C10.2044 12.8011 12.8011 10.2044 12.8048 7.00014Z"
        fill={fill}
      />
    </SimpleIcon>
  );
}
